import React from "react";
import "./Section.css"

type Props = {
    title: string;
    expanded: boolean;
    onToggle: () => void;
    metaLeft?: React.ReactNode;
    headerRight?: React.ReactNode;
    children?: React.ReactNode;
};

export function Section({ title, expanded, onToggle, metaLeft, headerRight, children }: Props) {
    return (
        <div className="section-container">
            <div className="section-header" onClick={onToggle}>
                <span style={{ marginRight: 10 }}>
                    {expanded ? "▾" : "▸"}
                </span>

                <strong className="section-title">{title}</strong>

                {metaLeft && (
                    <span className="section-meta">
                        {metaLeft}
                    </span>
                )}

                {headerRight}
            </div>

            {expanded && (
                <div className="section-content">
                    {children}
                </div>
            )}
        </div>
    );
}